import $ from 'jquery'
import OverlayScrollbars from 'overlayscrollbars'

$(document).ready(function () {
  dhsv_vc_scrollable_image()
})

function dhsv_vc_scrollable_image() {
  // eslint-disable-next-line no-unused-vars
  var dhsv_vc_scrollable_image = OverlayScrollbars(
    document.getElementById('dhsv_vc_scrollable_image'),
    {
      className: 'os-theme-round-dark',
      resize: 'none',
      sizeAutoCapable: true,
      paddingAbsolute: true,
      scrollbars: {
        visibility: 'visible',
        autoHide: 'never',
        autoHideDelay: 800,
        dragScrolling: true,
        clickScrolling: false,
        touchSupport: true,
        snapHandle: false,
      },
    }
  )
}
